export default  {
    component: 'weather_station_param',
    name: 'weather_station_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `Their are 2 options for module:
            - **live**
            - **analytics**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **live** [Parameter Options : irradiance_horizontal,irradiance_vertical,ambient_temp,wind_speed,direction]
            - **analytics** [Parameter Options : wind_speed, direction, humidity, pressure, irradiance_horizontal, irradiance_vertical, radiation, module_temp, aux_supply_voltage, rain_gauge, ambient_temp]`
          }
    ]
  }
